import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import car from '../../../assets/images/car.svg';
import truck from '../../../assets/images/truck.svg';
import minivan from '../../../assets/images/minivan.svg';
import bus from '../../../assets/images/bus.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import bulkUpload from 'packages/novous_web/src/assets/icons/bulkUpload.svg';
import InputField from 'packages/novous_web/src/common/components/InputField';
import CustomDropDownInput from 'packages/novous_web/src/common/components/customDropDownInput';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import { useLocation, useNavigate } from 'react-router-dom';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import add from 'packages/novous_web/src/assets/icons/plusBlue.svg';
import { set } from 'react-datepicker/dist/date_utils';
import { ArrowBack } from '@mui/icons-material';
import BulkUploadModal from '../../../common/components/BulkUpload';
import DateField from 'packages/novous_web/src/common/components/DateField';
import dayjs from 'dayjs';
import { group } from 'console';

const AddNewVehicleForm = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const vehicleData = location.state || {};
  const [driverDoc, setDriverDoc] = useState<any>();
  const [isUploadModelOpen, setIsUploadModelOpen] = useState(false);
  const isEdit = !!vehicleData.vehicleRegistrationNo;
  const [deviceIdValid, setDeviceIdValid] = useState(false);
  const [regNoValid, setRegNoValid] = useState(false);
  console.log('vehicleData', vehicleData);
  const [validationStates, setValidationStates] = useState<any>({
    deviceId: { isValid: null, loading: false },
    vehicleRegNo: { isValid: null, loading: false },
  });
  const [driverOptions, setDriverOptions] = useState<{ value: string; label: string }[]>([]);
  const [errors, setErrors] = useState({
    vehicleRegistrationNo: '',
    deviceId: '',
    vehicleType: '',
    vehicleName: '',
    vehicleProductType: '',
    groupName: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [successMessage, setSuccessMessage] = useState({ message: '', type: 'success' });
  const {
    data: DriversData,
    error: DriversError,
    loading: DriversLoading,
    fetchData: fetchDriversData,
  } = useAxios<{ data: { drivers: any[]; lastEvaluatedKey: null } }>(
    `${API_ENDPOINTS.directories.GET_ALL_DRIVER}`,
    'POST',
  );

  const {
    data: VehicleProductType,
    error: VehicleProductTypeError,
    loading: VehicleProductTypeLoading,
    fetchData: fetchVehicleProductTypeData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.VEHICLEPRODUCTTYPE}`, 'GET');

  useEffect(() => {
    fetchVehicleProductTypeData();
  }, []);

  // Disallow + - = @ anywhere (same as before)
  const SAFE_TEXT = /^[^+=@\-]*$/;
  const DEVICE_ID_ALLOWED = /^[A-Za-z0-9-]+$/;
  const Vehicle_Name_Allowed = /^[A-Za-z0-9\s]+$/;

  const validateField = (name: string, value: string): string => {
    const v = (value ?? '').trim();
    switch (name) {
      case 'vehicleName':
        if (!Vehicle_Name_Allowed.test(v)) return 'Vehicle name cannot contain special characters';
        return '';

      case 'vehicleRegistrationNo':
        if (!v) return 'Registration Number is required';
        if (!DEVICE_ID_ALLOWED.test(v)) return 'Registration Number cannot contain special characters';
        return '';

      case 'deviceId':
        if (!v) return 'DeviceId is required';
        if (!DEVICE_ID_ALLOWED.test(v)) return 'DeviceId cannot contain special characters';
        return '';

      default:
        return '';
    }
  };

  const validateForm = () => {
    const newErrors: any = {
      vehicleRegistrationNo: '',
      deviceId: '',
      vehicleType: '',
      vehicleName: '',
      vehicleProductType: '',
      groupName: '',
    };

    let isValid = true;

    // Vehicle Name
    if (!SAFE_TEXT.test(vehicleFormData.vehicleName.trim())) {
      newErrors.vehicleName = 'Vehicle name cannot contain + - = @';
      isValid = false;
    }

    // Registration No
    if (!vehicleFormData.vehicleRegistrationNo.trim()) {
      newErrors.vehicleRegistrationNo = 'Registration Number is required';
      isValid = false;
    } else if (!SAFE_TEXT.test(vehicleFormData.vehicleRegistrationNo.trim())) {
      newErrors.vehicleRegistrationNo = 'Registration Number cannot contain + - = @';
      isValid = false;
    }

    // Device ID
    if (!vehicleFormData.deviceId.trim()) {
      newErrors.deviceId = 'DeviceId is required';
      isValid = false;
    } else if (!SAFE_TEXT.test(vehicleFormData.deviceId.trim())) {
      newErrors.deviceId = 'DeviceId cannot contain + - = @';
      isValid = false;
    }

    // Vehicle Type (unchanged)
    if (!vehicleFormData.vehicleType.trim()) {
      newErrors.vehicleType = 'Vehicle type is required';
      isValid = false;
    }

    // Vehicle Product Type (unchanged)
    if (!vehicleFormData.vehicleProductType.trim()) {
      newErrors.vehicleProductType = 'Vehicle product type is required';
      isValid = false;
    }

    // Depot (Group Name)
    if (!vehicleFormData.groupName.trim()) {
      newErrors.groupName = 'Depot is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };
  const [vehicleFormData, setVehicleFormData] = useState({
    vehicleName: vehicleData.vehicleName || '',
    vehicleRegistrationNo: vehicleData.vehicleRegistrationNo || '',
    chassisNo: vehicleData.chassisNo || '',
    driverName: vehicleData.driverName || '',
    vehicleManufacturer: vehicleData.vehicleManufacturer || '',
    model: vehicleData.model || '',
    modelYear: vehicleData.modelYear || '',
    vehicleType: vehicleData.vehicleType || '',
    deviceType: vehicleData.deviceType || '',
    customerId: user?.customer_id || '',
    groupName: vehicleData.groupName || '',
    vehicleColor: vehicleData.vehicleColor || '',
    deviceId: vehicleData.deviceId || '',
    vehicleProductType: vehicleData.vehicleProductType || '',
    commissioningDate: vehicleData.commissioningDate || '',
  });

  const {
    data: groupsData,
    error: groupsError,
    loading: groupsLoading,
    fetchData: fetchGroupsData,
  } = useAxios<{ data: any }>(`${API_ENDPOINTS.dashboard.GROUP}${user?.customer_id}`, 'GET');

  const {
    data: VehicleData,
    error: VehicleError,
    loading: VehicleLoading,
    fetchData: fetchVehicleData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.ADD_VEHICLE}`, 'POST');
  const debouncedVehicleRegistrationNumber = useDebounce(vehicleFormData.vehicleRegistrationNo, 1000);
  const debouncedDeviceId = useDebounce(vehicleFormData.deviceId, 500);
  const {
    data: checkDeviceExistData,
    fetchData: checkDeviceExist,
    loading: deviceCheckLoading,
    error: deviceCheckError,
  } = useAxios<any>(`${API_ENDPOINTS.directories.VEHICLE_DEVICE_EXIST}/${debouncedDeviceId}`, 'POST');

  const {
    data: checkVehicleExistData,
    fetchData: checkVehicleExist,
    loading: vehicleCheckLoading,
    error: vehicleCheckError,
  } = useAxios<any>(
    `${API_ENDPOINTS.directories.VEHICLE_REGISTRATION_EXIST}/${debouncedVehicleRegistrationNumber}`,
    'POST',
  );
  useEffect(() => {
    if (debouncedVehicleRegistrationNumber) checkVehicleExist();
  }, [debouncedVehicleRegistrationNumber]);

  useEffect(() => {
    if (checkDeviceExistData) setDeviceIdValid(true);
    else if (deviceCheckError) setDeviceIdValid(false);
  }, [checkDeviceExistData, deviceCheckError]);
  useEffect(() => {
    if (debouncedDeviceId) checkDeviceExist();
  }, [debouncedDeviceId]);
  useEffect(() => {
    if (checkDeviceExistData && checkDeviceExistData?.data) {
      setRegNoValid(false);
      setErrors((prev) => ({
        ...prev,
        deviceId: 'Device Already Mapped',
      }));
    } else {
      setRegNoValid(true);
    }
  }, [checkDeviceExistData, deviceCheckError]);
  useEffect(() => {
    if (checkVehicleExistData && checkVehicleExistData?.data) {
      setRegNoValid(false);
      setErrors((prev) => ({
        ...prev,
        vehicleRegistrationNo: 'Vehicle Already Mapped',
      }));
    } else {
      setRegNoValid(true);
    }
  }, [checkVehicleExistData, vehicleCheckError]);
  const {
    data: editVehicleData,
    loading: editLoading,
    error: editError,
    fetchData: editVehicle,
  } = useAxios<any>(API_ENDPOINTS.directories.VEHICLE_EDIT, 'POST');

  useEffect(() => {
    fetchGroupsData();
  }, []);

  useEffect(() => {
    fetchDriversData({ fleetId: user?.customer_id });
  }, [user?.customer_id]);

  useEffect(() => {
    if (DriversData?.data?.drivers) {
      const driverOptions = DriversData.data.drivers.map((driver: any) => ({
        value: driver.driverId,
        label: driver.driverName,
      }));
      setDriverOptions(driverOptions);
    }
  }, [DriversData]);

  let groupOptions: { value: string; label: string }[] = [];
  if (groupsData && groupsData?.data) {
    groupOptions = groupsData.data.map((item: string) => {
      return { value: item, label: item };
    });
  }

  const vehicleProductTypeOptions =
    VehicleProductType?.data?.map((type: string) => ({
      value: type,
      label: type,
    })) || [];

  const modelYears = Array.from({ length: 20 }, (_, i) => {
    const year = (new Date().getFullYear() - i).toString();
    return { value: year, label: year };
  });

  const handleDriverSelect = (code: string) => {
    setVehicleFormData((prev) => ({ ...prev, driverName: code }));
  };

  const handleManufacturerSelect = (code: string) => {
    setVehicleFormData((prev) => ({ ...prev, vehicleManufacturer: code }));
  };

  const handleVehicleIconSelect = (type: any) =>
    setVehicleFormData((prev) => ({ ...prev, vehicleType: type }));

  const handleDeviceTypeSelect = (type: any) => setVehicleFormData((prev) => ({ ...prev, deviceType: type }));

  const handleVehicleProductTypeSelect = (type: string) => {
    setVehicleFormData((prev) => ({ ...prev, vehicleProductType: type }));
    // Clear error when user selects a value
    if (errors.vehicleProductType) {
      setErrors((prev) => ({ ...prev, vehicleProductType: '' }));
    }
  };

  // const handleBulkUpload = () => {
  //     setSuccessMessage({ message: "", type: "" });
  //     setTimeout(() => {
  //         setSuccessMessage({ message: "In Progress", type: "error" });
  //     }, 100);
  // };

  const handleBulkAssign = () => {
    setSuccessMessage({ message: '', type: '' });
    setTimeout(() => {
      setSuccessMessage({ message: 'In Progress', type: 'error' });
    }, 100);
  };

  const handleCancel = () => navigate('../');

  const [selectedVehicle, setSelectedVehicle] = useState<string | null>(vehicleData.vehicleType || null);

  const vehicleOptions = [
    { label: 'Car', value: 'CAB', image: car },
    { label: 'Minivan', value: 'MINBUS', image: minivan },
    { label: 'Truck', value: 'TRUCK', image: truck },
    { label: 'Bus', value: 'BUS', image: bus },
  ];

  const handleSelect = (vehicle: string) => {
    setSelectedVehicle(vehicle);
    handleVehicleIconSelect(vehicle);
    setErrors((prev) => ({
      ...prev,
      vehicleType: '',
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    if (!validateForm()) {
      return;
    }
    const payload = {
      vehicleRegistrationNo: vehicleFormData.vehicleRegistrationNo,
      deviceId: vehicleFormData.deviceId,
      customerId: vehicleFormData.customerId,
      activeTime: '',
      lastAlarmDataTime: '',
      lastHealthDataTime: '',
      lastLatitude: 0,
      lastLongitude: 0,
      lastLocationAddress: '',
      lastErrorOccuredTime: '',
      lastIgnitionOnTime: '',
      lastErrorEndTime: '',
      powerTamperingStatus: 0,
      ignitionStatus: 0,
      cameraBlockStatus: 0,
      imuStatus: 0,
      cameraMalFunctionStatus: 0,
      dmsCameraStatus: 0,
      inCabinCameraStatus: 0,
      fcwCameraStatus: 0,
      rearCameraStatus: 0,
      signalStrengthStatus: 0,
      gpsStatus: 0,
      fovStatus: 0,
      sdCardStatus: 0,
      micStatus: 0,
      sosStatus: 0,
      lowVisibilityStatus: 0,
      errorStatus: 0,
      deviceType: vehicleFormData.deviceType,
      speakerStatus: 0,
      groupName: vehicleFormData.groupName,
      parentId: user?.parentId || '',
      dataSource: '',
      dsmCameraId: '',
      inCabinCameraId: '',
      rearCameraId: '',
      onlineState: 0,
      blurStatus: false,
      driverName: vehicleFormData.driverName,
      vehicleName: vehicleFormData.vehicleName,
      chassisNo: vehicleFormData.chassisNo,
      vehicleManufacturer: vehicleFormData.vehicleManufacturer,
      model: vehicleFormData.model,
      modelYear: vehicleFormData.modelYear,
      vehicleType: vehicleFormData.vehicleType,
      hasDevice: true,
      vehicleProductType: vehicleFormData.vehicleProductType,
      commissioning_date: vehicleFormData.commissioningDate
        ? dayjs(vehicleFormData.commissioningDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        : '',
    };

    if (isEdit) {
      editVehicle(payload);
    } else {
      fetchVehicleData(payload);
    }
  };

  const originalRegNo = (vehicleData.vehicleRegistrationNo || '').trim();
  const originalDevice = (vehicleData.deviceId || '').trim();
  const deviceUnchanged = isEdit && vehicleFormData.deviceId.trim() === originalDevice;
  const regNoUnchanged = isEdit && vehicleFormData.vehicleRegistrationNo.trim() === originalRegNo;

  const manufacturers = [
    { code: 'MB', label: 'Mercedes-Benz' },
    { code: 'AL', label: 'Ashok Leyland' },
    { code: 'TATA', label: 'TATA Motors' },
    { code: 'VOLVO', label: 'Volvo Trucks' },
    { code: 'SCANIA', label: 'Scania' },
    { code: 'MAHINDRA', label: 'Mahindra & Mahindra' },
    { code: 'EICHER', label: 'Eicher Motors' },
    { code: 'FORCE', label: 'Force Motors' },
    { code: 'BMW', label: 'BMW' },
    { code: 'AUDI', label: 'Audi' },
    { code: 'JCB', label: 'JCB India' },
    { code: 'CATERPILLAR', label: 'Caterpillar Inc.' },
    { code: 'BAJAJ', label: 'Bajaj Auto' },
    { code: 'HERO', label: 'Hero MotoCorp' },
    { code: 'TVS', label: 'TVS Motor Company' },
  ];
  const deviceTypes = [
    { value: 'fcw_dsm', label: 'FCW-DMS' },
    { value: 'fcw', label: 'FCW' },
    { value: 'dsm', label: 'DMS' },
    { value: 'vts', label: 'VTS' },
  ];

  const handleGroupChange = (selectedValue: string) => {
    setVehicleFormData((prev) => ({ ...prev, groupName: selectedValue }));

    // Clear error when user selects a value
    if (errors.groupName) {
      setErrors((prev) => ({
        ...prev,
        groupName: '',
      }));
    }
  };

  const handleCommissioningDateChange = (value: string | null) => {
    setVehicleFormData((prev) => ({ ...prev, commissioningDate: value || '' }));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setVehicleFormData((prevState) => ({ ...prevState, [name]: value }));
    if (name === 'vehicleName' || name === 'vehicleRegistrationNo' || name === 'deviceId') {
      const msg = validateField(name, value);
      setErrors((prev) => ({ ...prev, [name]: msg }));
    }
    if (isSubmitted && errors[name as keyof typeof errors]) {
      setErrors((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  useEffect(() => {
    if (VehicleData?.message === 'Save Vehicle Successfully') {
      setSuccessMessage({ message: 'Vehicle Added Successfully', type: 'success' });
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    }
  }, [VehicleData]);

  useEffect(() => {
    if (editVehicleData?.message === 'Edit Vehicle Successfully') {
      setSuccessMessage({ message: 'Vehicle Updated Successfully', type: 'success' });
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    }
  }, [editVehicleData]);

  const hasErrors = () => {
    return Object.values(errors).some((error) => error.trim() !== '');
  };
  const handleUploadModalClose = () => {
    setIsUploadModelOpen(false);
    fetchVehicleData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
  };
  const handleDriveDoc = (files: string[]) => {
    console.log(files, 'fles   ');

    setDriverDoc(files);
    // setSuccessMessage({ message: 'Driver Docs Uploaded Successfully', type: 'success' })
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          mb: 2, // Add some margin below the row
          mt: 4,
        }}
      >
        <button
          className="text-blue-600 font-medium flex items-center"
          onClick={() => navigate(-1)}
          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          <ArrowBack className="mr-1" /> Back
        </button>
      </Box>
      <AlertToast
        open={!!successMessage.message}
        message={successMessage.message}
        type={successMessage.type === 'success' ? 'success' : 'error'}
        onClose={() => setSuccessMessage({ message: '', type: '' })}
      />
      <div className="p-4">
        {/* Header with Add New Vehicle and Bulk Upload Button */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-6">
          <Typography
            variant="h4"
            style={{ fontFamily: 'Inter Tight', fontWeight: 600, fontSize: '24px', lineHeight: '36px' }}
          >
            {isEdit ? 'Edit Vehicle' : 'Add a New Vehicle'}
          </Typography>
          <CustomIconButton
            icon={<img src={bulkUpload} alt="download" width={24} height={24} />}
            text="Bulk Upload"
            background="transparent"
            outline={true}
            onClick={() => setIsUploadModelOpen(true)}
          />
        </div>

        {/* Assign Driver Section */}
        <div className="mb-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Typography
              variant="subtitle1"
              style={{
                fontFamily: 'Inter Tight',
                fontWeight: 600,
                fontSize: '14px',
                lineHeight: '21px',
                marginRight: '60px',
              }}
            >
              Driver
            </Typography>
            <div style={{ marginLeft: '140px' }}>
              <CustomIconButton
                icon={<img src={add} alt="download" width={24} height={24} />}
                text="Add Driver"
                background="transparent"
                outline={false}
                onClick={() => navigate('/directories/drivers/new')}
              />
            </div>
          </div>

          <div
            className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 items-center"
            style={{ width: '100%', maxWidth: '400px' }}
          >
            <CustomDropDownInput
              label=""
              options={driverOptions.map(({ value, label }) => ({
                value: label,
                label,
              }))}
              value={vehicleFormData.driverName}
              onChange={handleDriverSelect}
              placeholder="Select Driver"
              showDropdownArrow
            />
          </div>
        </div>

        {/* Vehicle Identification Section */}
        <div className="mb-6">
          <Typography
            variant="subtitle1"
            style={{
              fontFamily: 'Inter Tight',
              fontWeight: 600,
              fontSize: '18px',
              lineHeight: '27px',
              letterSpacing: '0%',
              marginBottom: '20px',
            }}
          >
            Vehicle Identification
          </Typography>

          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
            <InputField
              label="Vehicle name"
              name="vehicleName"
              value={vehicleFormData.vehicleName}
              onChange={handleChange}
              placeholder="Enter vehicle name"
              status={errors.vehicleName ? 'error' : undefined}
              errorMessage={errors.vehicleName}
            />
            <InputField
              label="Vehicle Registration Number"
              name="vehicleRegistrationNo"
              value={vehicleFormData.vehicleRegistrationNo}
              onChange={handleChange}
              placeholder="Enter vehicle registration number"
              isDisabled={isEdit}
              status={
                errors.vehicleRegistrationNo && !regNoUnchanged
                  ? 'error' // <-- show error instead of green tick
                  : regNoValid || isEdit
                  ? 'success'
                  : undefined
              }
              isMandatory
              errorMessage={!isEdit ? errors.vehicleRegistrationNo : ''}
            />
            <InputField
              label="VN / Chassis Number"
              name="chassisNo"
              value={vehicleFormData.chassisNo}
              onChange={handleChange}
              placeholder="Enter VN / chassis number"
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 mb-4">
          <div className="flex flex-col gap-2 w-full">
            <Typography
              variant="subtitle1"
              style={{
                fontFamily: 'Inter Tight',
                fontWeight: 600,
                fontSize: '18px',
                lineHeight: '27px',
                letterSpacing: '0%',
              }}
            >
              Choose Vehicle Icon{' '}
              <span className="text-red-500" title="Required field">
                *
              </span>
            </Typography>
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              {vehicleOptions.map((option) => (
                <div key={option.value} className="flex flex-col items-center">
                  <Button
                    variant="outlined"
                    onClick={() => handleSelect(option.value)}
                    style={{
                      padding: '6px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: selectedVehicle === option.value ? '2px solid blue' : '1px solid gray',
                      borderRadius: '4px',
                      opacity: isEdit ? 0.5 : 1,
                      cursor: isEdit ? 'not-allowed' : 'pointer',
                    }}
                    disabled={isEdit}
                  >
                    <img src={option.image} alt={option.label} style={{ width: '28px', height: '28px' }} />
                  </Button>
                  <span className="mt-2 text-sm font-semibold text-gray-700">{option.label}</span>
                </div>
              ))}
            </div>
            {errors.vehicleType && (
              <Typography color="error" variant="body2" style={{ marginTop: '8px' }}>
                {errors.vehicleType}
              </Typography>
            )}
          </div>

          <Box className="w-full flex flex-col gap-1">
            <CustomDropDownInput
              label="Vehicle Product Type"
              options={vehicleProductTypeOptions}
              value={vehicleFormData.vehicleProductType}
              onChange={handleVehicleProductTypeSelect}
              placeholder="Select Vehicle Product Type"
              showDropdownArrow
              isMandatory
            />
            {errors.vehicleProductType && (
              <Typography color="error" variant="body2" style={{ marginTop: '8px' }}>
                {errors.vehicleProductType}
              </Typography>
            )}
          </Box>

          <DateField
            label="Commissioning Date"
            name="commissioningDate"
            value={vehicleFormData.commissioningDate}
            onChange={handleCommissioningDateChange}
            maxDate={dayjs().format('DD/MM/YYYY')}
          />
        </div>

        {/* Vehicle Details Section */}
        <div className="mb-6">
          <Typography
            variant="subtitle1"
            style={{
              fontFamily: 'Inter Tight',
              fontWeight: 600,
              fontSize: '18px',
              lineHeight: '27px',
              letterSpacing: '0%',
              marginBottom: '20px',
            }}
          >
            Vehicle Details
          </Typography>
          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 mb-4">
            <CustomDropDownInput
              label="Manufacturer"
              options={manufacturers.map(({ code, label }) => ({
                value: code,
                label,
              }))}
              value={vehicleFormData.vehicleManufacturer}
              onChange={handleManufacturerSelect}
              placeholder="Select Manufacturer"
              showDropdownArrow
            />
            <InputField
              label="Model"
              name="model"
              value={vehicleFormData.model}
              onChange={handleChange}
              placeholder="Enter model"
            />
            <Box className="flex flex-col gap-1 w-full">
              <CustomDropDownInput
                label="Depot"
                options={groupOptions}
                value={vehicleFormData.groupName}
                onChange={handleGroupChange}
                placeholder="Select Depot"
                showDropdownArrow
                isMandatory
                status={errors.groupName ? 'error' : vehicleFormData.groupName ? 'success' : undefined}
              />
              {errors.groupName && (
                <Typography color="error" variant="body2" style={{ marginTop: '8px' }}>
                  {errors.groupName}
                </Typography>
              )}
            </Box>
          </div>
          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
            <InputField
              label="Device Id"
              name="deviceId"
              value={vehicleFormData.deviceId}
              onChange={handleChange}
              placeholder="Enter your DeviceId"
              // status={deviceIdValid ? 'success' : 'error'}
              //status={errors.deviceId ? 'error' : (deviceIdValid ? 'success' : undefined)}
              status={
                errors.deviceId && !deviceUnchanged
                  ? 'error'
                  : deviceIdValid || deviceUnchanged
                  ? 'success'
                  : undefined
              }
              // status={
              //   errors.deviceId
              //     ? 'error'                                  // <-- show error instead of green tick
              //     : (deviceIdValid ? 'success' : undefined)
              // }
              // isDisabled={deviceIdValid}
              isMandatory
              errorMessage={isSubmitted ? errors.deviceId : ''}
            />
            <CustomDropDownInput
              label="Device Type"
              options={deviceTypes.map(({ value, label }) => ({
                value: value,
                label,
              }))}
              // isDisabled={isEdit}
              value={vehicleFormData.deviceType}
              onChange={handleDeviceTypeSelect}
              placeholder="Select Device Type"
              showDropdownArrow
            />
            <CustomDropDownInput
              label="Year"
              options={modelYears}
              value={vehicleFormData.modelYear}
              onChange={(year) => setVehicleFormData((prev) => ({ ...prev, modelYear: year }))}
              placeholder="Select Year"
              showDropdownArrow
            />
          </div>
        </div>

        {/* Customer Information Section */}
        <div className="mb-6">
          <Typography
            variant="subtitle1"
            style={{
              fontFamily: 'Inter Tight',
              fontWeight: 600,
              fontSize: '18px',
              lineHeight: '27px',
              letterSpacing: '0%',
              marginBottom: '20px',
            }}
          >
            Customer Information
          </Typography>
          <InputField
            label="Customer ID"
            name="customerId"
            value={vehicleFormData.customerId}
            onChange={handleChange}
            isMandatory={true}
            isDisabled={true}
            placeholder="Enter customer ID"
          />
        </div>

        <div className="relative w-full mt-auto">
          <div className="flex flex-col md:flex-row justify-between px-8 py-4 border-t bg-white">
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleCancel}
              style={{ fontFamily: 'Inter Tight', fontWeight: 600, fontSize: '14px', lineHeight: '21px' }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={
                !vehicleFormData.vehicleRegistrationNo.trim() ||
                !vehicleFormData.deviceId.trim() ||
                !vehicleFormData.vehicleType.trim()
              }
              color="primary"
              onClick={handleSubmit}
              style={{ fontFamily: 'Inter Tight', fontWeight: 600, fontSize: '14px', lineHeight: '21px' }}
            >
              {isEdit ? 'Update Vehicle' : 'Add Vehicle'}
            </Button>
          </div>
        </div>
      </div>
      {isUploadModelOpen && (
        <BulkUploadModal
          open={isUploadModelOpen}
          handleClose={handleUploadModalClose}
          handleDriveDoc={driverDoc}
        />
      )}
    </>
  );
};

export default AddNewVehicleForm;
